import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { readLandingLanguage } from "@/pages/LandingPages/roofingLight/landingLanguage";
import en from "./locales/en/roofingLight.json";
import es from "./locales/es/roofingLight.json";

const initialLanguage =
  typeof window === "undefined" ? "en" : readLandingLanguage(window.location.search);

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { roofingLight: en },
      es: { roofingLight: es },
    },
    lng: initialLanguage,
    initImmediate: false,
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    ns: ["roofingLight"],
    defaultNS: "roofingLight",
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false, transSupportBasicHtmlNodes: false },
  });
}

export default i18n;
